// eslint-disable-next-line import/no-anonymous-default-export
export default {
  customizedCustomer: {
    custom: {
      title: "ENCOO HyperAutomation",
      description: "Welcome to use ENCOO HyperAutomation Enterprise Edition",
    },
  },
};
